<template>
  <div>
    <CustomDialog
      :show="show"
      :title="$t('public.view')"
      @toggleShow="handleClose"
      :appendToBody="true"
      width="800"
    >
      <div slot="main">
        <el-input :placeholder="$t('public.p2')" v-model="name" size="small" @keyup.enter.native="toSearch">
          <el-button
            slot="append"
            icon="el-icon-search"
            @click="toSearch"
          ></el-button>
        </el-input>
        <div class="tips">
          {{ $t("public.hasAuth") + ":" + rowInfo.stations?.length }}
        </div>
        <div class="stations" ref="stations" @scroll="handleScroll">
          <el-checkbox-group
            v-model="stationsValue"
            size="medium"
            @change="stationChange"
          >
            <el-checkbox-button
              v-for="station in stations"
              :label="station.id"
              :key="station.id"
              >{{ station.label }}</el-checkbox-button
            >
          </el-checkbox-group>
        </div>
      </div>
      <div slot="footer">
        <div class="btns">
          <el-button
            @click="confirm"
            type="primary"
            size="small"
            style="width: 100%"
            >{{ $t("public.submit") }}</el-button
          >
          <el-button @click="handleClose" size="small" style="width: 100%">{{
            $t("public.cancel")
          }}</el-button>
        </div>
      </div>
    </CustomDialog>
  </div>
</template>

<script>
import CustomDialog from "../../../components/public/customDialog";
export default {
  name: "OverseasStationManageViewList",
  components: {
    CustomDialog,
  },
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      default: "",
    },
    rowInfo: {
      type: Object,
      default: () => {
        return {};
      },
    },
    type: {
      type: String,
      default: "view",
    },
  },
  watch: {
    rowInfo: {
      handler(newV, oldV) {
        if ((newV, oldV)) {
          this.getStations();
        }
      },
      deep: true,
    },
  },
  data() {
    return {
      stationsValue: [],
      name: "",
      num: 20,
      stations: [],
    };
  },

  mounted() {},

  methods: {
    getStations(keyword = "") {
      if (this.rowInfo.stations && this.rowInfo.stations.length) {
        this.stations = [];
        this.rowInfo.stations.map((item, index) => {
          if (item && item.indexOf(keyword) > -1) {
            this.stations.push({
              label: item,
              id: index,
            });
          }
        });
      }
    },
    handleScroll() {
      const container = this.$refs.stations;
      const scrollHeight = container.scrollHeight;
      const scrollTop = container.scrollTop;
      const clientHeight = container.clientHeight;
      if (scrollTop + clientHeight >= scrollHeight && !this.loading) {
        // this.loadMore()
      }
    },
    stationChange(e) {
    },
    confirm() {
      this.handleClose()
      //
    },
    handleClose() {
      this.$emit("update:show", false);
    },
    toSearch() {
      let param = {};
      this.getStations(this.name);
    },
  },
};
</script>
<style lang="scss" scoped>
.btns {
  display: flex;
  justify-content: center;
  align-items: center;
}
.tips {
  width: 100%;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  margin: 10px 0;
}
.stations {
  max-height: 300px;
  overflow: auto;
}
</style>
